/**
 * Whether the RoadSense site report offers its workbook download / Export menu.
 * Kept free of React and `@src` imports so jest can test it directly.
 *
 * With `roadsense_camera_access` off it always does, as before. With it on, only
 * a tenant admin gets them: they still use the stored whole-site workbook and
 * the admin-only artifact and email-delivery routes, until the scoped export
 * and email routes (DEL-1249 steps 6 and 7) bring them to everyone else.
 *
 * `isTenantAdmin` is `undefined` while the answer is unknown; nothing is shown
 * until it is known, and a failed admin check should be passed as `false`.
 */
export function showsReportExportAction(viewer: {
  cameraScoped: boolean;
  isTenantAdmin: boolean | undefined;
}): boolean {
  if (!viewer.cameraScoped) return true;
  return viewer.isTenantAdmin === true;
}
